import { Pipe, PipeTransform } from "@angular/core";
import { FlightsService } from "../../flights-calendar/flights.service";

@Pipe({
    name: "helicopter",
    standalone: false,
})
export class HelicopterPipe implements PipeTransform {
    constructor(private _flightsService: FlightsService) {}

    transform(helicopterId: number, key: string): string {
        const helicoptersArray = this._flightsService.getHelicopters();
        const heliObj = helicoptersArray.filter((heli) => heli.id === helicopterId)[0];
        return !heliObj ? "N/D" : heliObj[key];
    }
}
